import { render, staticRenderFns } from "./MarketplaceGoodServices.vue?vue&type=template&id=72b841c3&scoped=true&"
import script from "./MarketplaceGoodServices.vue?vue&type=script&lang=js&"
export * from "./MarketplaceGoodServices.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceGoodServices.vue?vue&type=style&index=0&id=72b841c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b841c3",
  null
  
)

export default component.exports